<!--お仕事選択-->
<template>
  <div>
    <!--検索model-->
    <div class="search-module-i0018">
      <el-row style="padding-top:11px;padding-left:5px" :gutter="20">
        <el-col :span="9" align="middle">
          <span>{{jobDateTitle}}</span>
        </el-col>
      </el-row>
    </div>
    <el-table style=" border: 0px solid #AAAAAA ;width:100%" :header-cell-style="i0018HeaderStyle" :cell-style="i0018IsCellStyle" :header-row-class-name="i0018HeaderClass" :cell-class-name="i0018IsCellClass" :data="list" border @row-click="i0018RowOnClick" size="mini">
      <!--開始終了-->
      <el-table-column prop="col1" :label="$t('MODULE.I0017_LBL_START_AND_END')" width="130px;" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime}}<br>{{scope.row.endTime}}
        </template>
      </el-table-column>
      <!--店舗-->
      <el-table-column prop="col2" :label="$t('MODULE.I0017_LBL_COL2')" min-width="180px;" align="center">
        <template slot-scope="scope">
          {{scope.row.companyName}}<br>{{scope.row.storeName}}
        </template>
      </el-table-column>
      <!--お仕事内容-->
      <el-table-column prop="col3" :label="$t('MODULE.I0017_LBL_COL3')" min-width="160px;" align="center">
        <template slot-scope="scope">
          {{scope.row.jobContent}}
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align:center;padding-top: 10px;">
      <el-button class="css-btn css-button" type="primary" style="width:114px;height:34px;padding-top:10px;" @click="back">{{$t('COMMON.BTN_CANCEL')}}</el-button>
    </el-row>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0017"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  data() {
    return {
      jobDateTitle: '',
      login_userCd: '',//登陆者cd
      list: [],
    };
  },
  created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.login_userCd = userInfo.userCd
    var date = ''
    date = this.$route.query.jobDate
    if (date) {
      this.jobDateTitle = date.split('/')[0] + this.$t('MODULE.P0002_LBL_MONTH') + date.split('/')[1] + this.$t('MODULE.P0002_LBL_YEAR') + date.split('/')[2] + this.$t('MODULE.S0001_LBL_CALENDAR_SUN')
    }
    // 期間より検索
    this.query()
  },
  methods: {
    back() {
      this.$router.push({ path: url.routerUrl_I0017 })
    },
    // 検索
    async query() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      // 検索処理
      await amsApi.i_0017_select_search(this.$route.query.jobDate, this.login_userCd).then(res => {
        if (res.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          return
        } else {
          //更新基本list
          this.list = res.items.jobSelectInfoList;
        }
        loading.close()
      })
    },
    // TABLEHeader样式
    i0018HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; '
    },
    // TABLE单元格样式
    i0018IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      if (row.applyStatus == '1') {
        return 'text-align:center;fontSize:10pt;background-color:#DFEDF2;'
      } else if (row.applyStatus == '2') {
        return 'text-align:center;fontSize:10pt;background-color:#DCDCDC;'
      } else {
        return 'text-align:center;fontSize:10pt;'
      }
    },
    // 单击行事件
    i0018RowOnClick(thisRowDate, column, cell, event) {
      if (thisRowDate.applyStatus == '2') {
        return
      }
      var recruitNo = thisRowDate.recruitNo
      var fieldCd = thisRowDate.fieldCD
      var jobDate = this.$route.query.jobDate
      var editShow = false
      this.list.forEach((item) => {
        if (item.fieldCD != thisRowDate.fieldCD) {
          if (item.applyStatus == '1') {
            editShow = true
          }
        }
      })
      //计划的场合，点击无效
      this.$router.push({ path: url.routerUrl_I0019, query: { recruitNo: recruitNo, fieldCd: fieldCd, jobDate: jobDate, editShow: editShow } })
    },
    i0018HeaderClass({ row, rowIndex }) {
      return 'i0018HeaderClass'
    },
    i0018IsCellClass({ row, rowIndex }) {
      return 'i0018IsCellClass'
    },
  },
}

</script>
<style scope>
/*カラー*/
.css-white {
  color: #ffffff;
}
.i0018IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.i0018HeaderClass .cell {
  white-space: pre-line;
}
.search-module-i0018 {
  padding-bottom: 10px;
  margin-bottom: 5px; /*检索模块与表格间距*/
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
  border: solid 0px #999999;
}
/*ボタン*/
.css-button_i0018 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 10pt;
}
/*按钮经过样式*/
.css-btn_i0018:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_i0018:active,
.css-btn_i0018:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.css-btn_i0018.is-disabled,
.css-btn_i0018.is-disabled:focus,
.css-btn_i0018.is-disabled:hover {
  background-image: linear-gradient(#5bd3ff, #5bd3ff);
  color: #ffffff;
}

/*ボタン*/
.css-button_i0018_l {
  background-image: linear-gradient(#fad52e, #daa516);
  color: #ffffff;
  width: 100%;
}
/*按钮经过样式*/
.css-btn_i0018_l:hover {
  background-image: linear-gradient(0deg, #fad52e, #d1a838);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_i0018_l:active,
.css-btn_i0018_l:focus {
  background-image: linear-gradient(#fad52e, #daa516);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.css-btn_i0018_l.is-disabled,
.css-btn_i0018_l.is-disabled:focus,
.css-btn_i0018_l.is-disabled:hover {
  background-image: linear-gradient(#ffd373, #ffd373);
  color: #ffffff;
}

/*导航*/
.home-content-menu_i0018 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}
/*面包屑*/
.el-crumb_i0018 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
</style>





// WEBPACK FOOTER //
// src/module/page/i_0018.vue